<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </div>
</template>

<script>
    import crudMixins from "@/mixins/crud-mixins";
    import {getList, add, update, remove, getDetail} from "./api";
    import {searchTimeConfig} from "@/basic-common/util/common";

    export default {
        mixins: [crudMixins],
        data() {
            return {
                apiConfig: {getList, add, update, remove, getDetail},
                infoCardData: [], // 卡片数据
                option: {
                    ...this.$store.state.publicOption,
                    column: [
                        {
                            label: '设备ID',
                            prop: 'deviceId',
                        },
                        {
                            label: '设备分类',
                            prop: 'category',
                        },
                        {
                            label: '设备类型',
                            prop: 'deviceType',
                        },
                        {
                            label: '设备名称',
                            prop: 'deviceName',
                            search: true, // 查询是否显示
                            minWidth: 150, // 表格最小宽度
                            type: 'select',
                            remote: true,
                            dicUrl: '/api/produce/device-alarm-records/select/distinct/page?deviceName={{key}}',
                            props: {
                                label: 'deviceName',
                                value: 'deviceName'
                            },
                            dicFormatter: (res) => {
                                return res.records
                            },
                        },
                        {
                            label: '提醒类型',
                            prop: 'alertType',
                        },
                        {
                            label: '类型',
                            prop: 'type',
                        },
                        {
                            label: '处理机制',
                            prop: 'handlingMechanism',
                        },
                        {
                            label: '当前数值',
                            prop: 'currentValue',
                        },
                        {
                            label: '阈值数值',
                            prop: 'thresholdValue',
                        },
                        {
                            label: '报警时间',
                            prop: 'alertTime',
                            type: 'datetime',
                            format: 'yyyy-MM-dd HH:mm:ss',
                            valueFormat: 'yyyy-MM-dd HH:mm:ss',
                            minWidth: 120,
                        },
                        {
                            label: '4-已关闭',
                            prop: 'alertStatus',
                        },
                        {
                            label: '处理人ID',
                            prop: 'processorId',
                        },
                        {
                            label: '处理人姓名',
                            prop: 'processorName',
                            search: true, // 查询是否显示
                            minWidth: 150, // 表格最小宽度
                            type: 'select',
                            remote: true,
                            dicUrl: '/api/produce/device-alarm-records/select/distinct/page?processorName={{key}}',
                            props: {
                                label: 'processorName',
                                value: 'processorName'
                            },
                            dicFormatter: (res) => {
                                return res.records
                            },
                        },
                        {
                            label: '处理时间',
                            prop: 'processTime',
                            type: 'datetime',
                            format: 'yyyy-MM-dd HH:mm:ss',
                            valueFormat: 'yyyy-MM-dd HH:mm:ss',
                            minWidth: 120,
                        },
                        {
                            label: '处理结果',
                            prop: 'processResult',
                        },
                        {
                            label: '1-是',
                            prop: 'isNotified',
                        },
                        {
                            label: '备注',
                            prop: 'remark',
                        },
                        {
                            label: '创建人ID',
                            prop: 'createUser',
                        },
                        {
                            label: '创建人姓名',
                            prop: 'createName',
                            search: true, // 查询是否显示
                            minWidth: 150, // 表格最小宽度
                            type: 'select',
                            remote: true,
                            dicUrl: '/api/produce/device-alarm-records/select/distinct/page?createName={{key}}',
                            props: {
                                label: 'createName',
                                value: 'createName'
                            },
                            dicFormatter: (res) => {
                                return res.records
                            },
                        },
                        {
                            label: '创建时间',
                            prop: 'createTime',
                            type: 'datetime',
                            format: 'yyyy-MM-dd HH:mm:ss',
                            valueFormat: 'yyyy-MM-dd HH:mm:ss',
                            minWidth: 120,
                        },
                        {
                            label: '1=有效',
                            prop: 'status',
                        },
                        {
                            ...searchTimeConfig,
                            paramsKey: ["startTime", "endTime"],
                        },
                    ]
                },
            }
        }
    }
</script>
<style scoped lang="scss">
</style>
